import rpc from './core'

const urls = {
  register: {
    url: '/auth/register',
    method: 'POST'
  },
  authenticate: {
    url: '/auth/login',
    method: 'POST'
  },
  auth_by_network: {
    url: '/auth/login',
    method: 'POST'
  },
  autologin: {
    url: '/auth/autologin/{code}',
    method: 'GET'
  },
  refresh: {
    url: '/auth/refresh',
    method: 'GET'
  },
  reset: {
    url: '/auth/reset',
    method: 'POST'
  },
  confirm: {
    url: '/auth/confirm',
    method: 'POST'
  },
  resend: {
    url: '/auth/resend',
    method: 'POST'
  },
  change_password: {
    url: '/auth/change',
    method: 'POST'
  },
  check_invite: {
    url: '/auth/invite',
    method: 'POST'
  }
}

const register = async (profile, parish, captcha, invite, locale) => {
  let data = { profile }
  if (parish) {
    data.parish = parish.id
  }
  if (captcha) {
    data.captcha = captcha
  }
  if (invite) {
    data.invite = invite
  }
  if (locale) {
    data.locale = locale
  }

  return rpc({ data, ...urls['register'] })
}
const authenticate = async (credentials) => {
  return rpc({ data: credentials, ...urls['authenticate'] })
}
const authByNetwork = async (network, profile, token, parish) => {
  if (parish) {
    parish = parish.id
  }
  return rpc({ data: { network, profile, parish, token }, ...urls['auth_by_network'] })
}
const autologin = async (code) => {
  return rpc({ params: { code }, ...urls['autologin'] })
}
const refresh = async () => {
  return rpc({ ...urls['refresh'] })
}
const getResetCode = async (email) => {
  return rpc({ data: { email }, ...urls['reset'] })
}
const checkConfirmCode = async (code) => {
  return rpc({ data: { code }, ...urls['confirm'] })
}
const resendConfirmCode = async (code) => {
  return rpc({ data: { code }, ...urls['resend'] })
}
const changePassword = async (password) => {
  return rpc({ data: { password }, ...urls['change_password'] })
}
const checkInvite = async (invite) => {
  return rpc({ data: { invite }, ...urls['check_invite'] })
}

export default { register, authenticate, authByNetwork, autologin, refresh, getResetCode, checkConfirmCode, resendConfirmCode, changePassword, checkInvite }
